/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IAdhocViewPropertiesProperties } from '../../bi/adhoc/AdHocView2Types';
import { IReducerAction, IReducerActionData } from '../store/types/ReducerTypes';

const APIActions = {
    API_PROPERTIES_UPDATE: 'API_PROPERTIES_UPDATE',
    API_REFRESH: 'API_REFRESH',
    API_DESTROY: 'API_DESTROY',
    API_RESIZE: 'API_RESIZE'
};

function passProperties(visProps: IAdhocViewPropertiesProperties, deferred: JQueryDeferred<any>): IReducerAction<IReducerActionData> {
    return {
        type: APIActions.API_PROPERTIES_UPDATE,
        data: { properties: visProps, deferredAction: deferred }
    };
}

function refresh(deferred: JQueryDeferred<any>): IReducerAction<IReducerActionData> {
    return {
        type: APIActions.API_REFRESH,
        data: { deferredAction: deferred }
    };
}

function destroy(deferred: JQueryDeferred<any>): IReducerAction<IReducerActionData> {
    return {
        type: APIActions.API_DESTROY,
        data: { deferredAction: deferred }
    };
}

function resize(width: number, height: number): IReducerAction<IReducerActionData> {
    return {
        type: APIActions.API_RESIZE,
        data: {
            properties: {
                width, height
            }
        }
    };
}

export {
    APIActions, passProperties, refresh, destroy, resize
};
